import serializeForm from "@/utils/serializeForm.js";
import ajaxRequest from "@/utils/ajaxRequest.js";
import processAjaxResponse from "@/utils/processAjaxResponse.js";
import showMessage from "@/utils/showMessage.js";
import clearForm from "@/utils/clearForm.js";

export default function (element, data) {
    const url = element.action;
    let preventSend = false;
    
    element.addEventListener("submit", async function (event) {
        event.preventDefault();

        if (preventSend) {
            return;
        }

        const formData = serializeForm(element);
        const postData = Object.assign({
            data: {
                form: formData
            }
        }, window.Application.config);

        element.querySelectorAll('.field-error').forEach(fieldElement => fieldElement.classList.remove("field-error"));

        preventSend = true;
        Array.from(element.elements).forEach(formElement => formElement.readOnly = true);
        element.classList.add("loading");
        const response = await ajaxRequest(url, postData);
        element.classList.remove("loading");
        Array.from(element.elements).forEach(formElement => formElement.readOnly = false);
        preventSend = false;
        
        processAjaxResponse(response, (message, data) => { // В случае успеха
            if (data.redirect) {
                window.location = data.redirect;
            } else {
                clearForm(element);
                showMessage(message);
                window.dispatchEvent(new Event("closePopupForm"));
            }
        }, (message, data) => { // В случае ошибки
            showMessage(message);

            if (data && data.errorFields) {
                data.errorFields.forEach(field => {
                    const fieldElement = element.querySelector('*[name="' + field + '"]');
                    if (fieldElement) {
                        const parentElement = fieldElement.closest('.field-error-target');

                        if (parentElement) {
                            parentElement.classList.add("field-error");
                        } else {
                            fieldElement.classList.add("field-error");
                        }
                    }
                });
            }
        });
    });
            
    element.querySelectorAll("input, textarea, select").forEach(fieldElement => {
        fieldElement.addEventListener("input", function () {
            fieldElement.classList.remove("field-error");

            const parentElement = fieldElement.closest('.field-error-target');

            if (parentElement) {
                parentElement.classList.remove("field-error");
            }
        });
    });
}

// @widgetLoadingMode:lazy-once
// @widgetLoadingChunk:secondary